var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"sf-button--pure a-account-icon",on:{"click":_vm.goToAccount}},[_c('img',{attrs:{"src":"/assets/custom/icons/icon-account-dark.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }